module.exports = __webpack_public_path__ + "static/diyanet6-032ed1d1b62f9a95895ba8c32e2dec0c.png";